export enum ReportTypes {
  RETIREMENT,
  DELIVER,
  CONSOLIDATED,
  USER_DELIVERY,
  USERS,
}
